export const Company=[
    {
        link:"About Us",
    },
    {
        link:"Careers",
    },
    {
        link:"Blog",
    },
    {
        link:"Partner with PharmEasy",
    },
    {
        link:"Sell at PharmEasy",
    }
]

export const OurServices=[
    {
        link:"Order Medicine"
    },
    {
        link:"Healthcare Products"
    },
    {
        link:"Lab Tests"
    },
]


export const Categories=[
    {
        link:"Covid Essentials"
    },
    {
        link:"Personal Care"
    },
    {
        link:"Health Food and Drinks"
    },
    {
        link:"Beauty"
    },
    {
        link:"Skin Care"
    },
    {
        link:"Home Care"
    },
    {
        link:"Ayurvedic Care"
    },
    {
        link:"Sexual Wellness"
    },
    {
        link:"Fitness & Supplements"
    },
    {
        link:"Mother and Baby Care"
    },
  
]

export const NeedHelp=[
    {
        link:"Browse All Medicines"
    },
    {
        link:"Browse All Molecules"
    },
    {
        link:"Browse All Cities & Areas"
    },
    {
        link:"Browse All Stores"
    },
    {
        link:"FAQs"
    },
]

export const PolicyInfo=[
    {
        link:"Editorial Policy"
    },
    {
        link:"Privacy Policy"
    },
    {
        link:"Vulnerability Disclosure Policy"
    },
    {
        link:"Terms and Conditions"
    },
    {
        link:"Customer Support Policy"
    },
    {
        link:"Return Policy"
    },
]

export const Partners=[
    {
        img:"https://assets.pharmeasy.in/apothecary/images/gpay.png?dim=1440x0",
    },
    {
        img:"https://assets.pharmeasy.in/apothecary/images/paytm.png?dim=1440x0",
    },
    {
        img:"https://assets.pharmeasy.in/apothecary/images/phonepe.png?dim=1440x0",
    },
    {
        img:"https://assets.pharmeasy.in/apothecary/images/amazon.png?dim=1440x0",
    },
    {
        img:"https://assets.pharmeasy.in/apothecary/images/mobikwik.png?dim=1440x0",
    },
    {
        img:"https://assets.pharmeasy.in/apothecary/images/olamoney.png?dim=1440x0",
    },
    {
        img:"https://assets.pharmeasy.in/apothecary/images/maestro.png?dim=1440x0",
    },
    {
        img:"https://assets.pharmeasy.in/apothecary/images/mastercard.png?dim=1440x0",
    },
    {
        img:"https://assets.pharmeasy.in/apothecary/images/visa.png?dim=1440x0",
    },
    {
        img:"https://assets.pharmeasy.in/apothecary/images/rupay.png?dim=1440x0",
    },
]
